/** SelectCreateFooter — 挂在必选下拉列表底部的「新建」入口。
 *
 * 用于「选项为空就走不下去」的必填下拉：律师首次使用系统时事项、客户都还没有，
 * 如果下拉里没有新建入口，就必须放弃当前弹窗、去另一个页面把前置数据建好再回来。
 * 把新建入口放进下拉，使整条流程可以在原地完成。
 *
 * 作为 antd Select 的 popupRender 使用：
 *   popupRender={(menu) => (
 *     <SelectCreateFooter menu={menu} label="新建客户" onCreate={...} />
 *   )}
 */

import type { ReactNode } from "react";
import { PlusOutlined } from "@ant-design/icons";
import styles from "../../styles/form-modal.module.css";

interface SelectCreateFooterProps {
  /** antd 传入的原始选项列表 */
  menu: ReactNode;
  /** 按钮文案，如「新建客户」 */
  label: string;
  onCreate: () => void;
  testId?: string;
}

export default function SelectCreateFooter({
  menu,
  label,
  onCreate,
  testId,
}: SelectCreateFooterProps) {
  return (
    <>
      {menu}
      <div className={styles.selectCreateDivider} />
      <button
        type="button"
        className={styles.selectCreateBtn}
        // 阻止 mousedown 让 Select 抢走焦点：否则下拉会在 click 触发前收起，
        // 点击落空，用户会以为按钮坏了。
        onMouseDown={(e) => e.preventDefault()}
        onClick={onCreate}
        data-testid={testId}
      >
        <PlusOutlined />
        <span>{label}</span>
      </button>
    </>
  );
}
